import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.06, delayChildren: 0.08 } },
};
const word = {
  hidden: { y: "110%" },
  visible: { y: "0%", transition: { duration: 0.8, ease: EASE } },
};

// Masked word-by-word rise, revealed once on scroll into view.
// Mirrors the homepage hero H1 treatment.
export default function WordsRise({ text, as = "h2", className = "", style, testid }) {
  const MotionTag = motion[as];
  return (
    <MotionTag
      data-testid={testid}
      aria-label={text}
      className={className}
      style={style}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-12%" }}
    >
      {text.split(" ").map((w, i) => (
        <span key={i} aria-hidden="true" className="mr-[0.22em] inline-block overflow-hidden align-bottom">
          <motion.span variants={word} className="inline-block">
            {w}
          </motion.span>
        </span>
      ))}
    </MotionTag>
  );
}
